import React from "react";
import ConfettiIcon from "../icons/ConfettiIcon";
import { Typography } from "./typography";
import { cn } from "@aichat/ui/lib/utils";

type SubmittedSurveyProps = {} & React.HtmlHTMLAttributes<HTMLDivElement>;
const SubmittedSurvey = ({ ...props }: SubmittedSurveyProps) => {
  return (
    <div
      {...props}
      className={cn("p-6 flex flex-col gap-6 items-center", props.className)}
    >
      <ConfettiIcon className="size-20" />
      <div>
        <Typography variant="h5">Thanks for your feedback!</Typography>
        <Typography variant="subtle">
          We love hearing from you and appreciate your time.
        </Typography>
      </div>
    </div>
  );
};

export default SubmittedSurvey;
